import _ from 'lodash'
import moment from 'moment'
import Client from "data/_client"
import notifcationService from 'data/notification'
import propertyService from 'data/property'
import { parseErrorsToErrorTable } from 'data/lib/validation'
import underwritingService from './underwriting'
import { formatDate, parseDate } from "data/lib/dates"
import notificationService from 'data/notification'

// private module logic //

const host = process.env.JSREPORT_API;
const jsreport = process.env.JSREPORT_API;

function getReportTermDefault():number {
  const currentProperty = propertyService.get();
  const valuationDetail = currentProperty['valuationdetail'];
  const defaultScenario = _.find(valuationDetail, s => s.defaultScenario);
  const propertyTermVal = currentProperty['term'] + 1
  let maxTerm = getUnderwritingTermMax(defaultScenario);
  // Rule: 'Default Term to lesser of 11 and maximum term', but other logic for
  // validating and adjusting user input can use previous algorithm of computing max term
  return maxTerm >= 11 ? 11 : propertyTermVal <= 11 ? propertyTermVal : 11
}

function getUnderwritingTermMax(scenario:object):number {
  const property = propertyService.get();
  const analysisBegin = moment(property['analysisbegindate']);
  const reportBegin   = moment(property['reportbegindate']);
  const valuationDate = moment(scenario['valuationDate'] || reportBegin);

  let maxTerm = Math.floor(
    (12 * (analysisBegin.year() - valuationDate.year() + property['term']) +
      (analysisBegin.month() + 1 - (valuationDate.month() + 1))) /
      12
  )
  if (maxTerm > 20) maxTerm = 20;
  if (maxTerm < 1) maxTerm = 1;
  return maxTerm;
}

function updateDate(date: string, term: number, prop?:object){
  const property = prop || propertyService.get();
  const analysisBegin = property['analysisbegindate']
  const maxDate = validateStartDate()[1];

  if (parseDate(date).isBefore(parseDate(analysisBegin))){
    date = analysisBegin;
    notifcationService.notify({
      type: "warn",
      message: 'Report Begin Date adjusted to earliest possible date, the Analysis Begin',
      dismiss: 5000
    })
  }

  if (parseDate(date).isAfter(parseDate(maxDate))){
    date = maxDate;
    notifcationService.notify({
      type: "warn",
      message: 'Report Display Date adjusted to the max date',
      dismiss: 5000
    })
  }

  let validatedTerm:number|boolean = false
  let validated = validateTerm(term, date);
  validatedTerm = validated;

  return { adjustedDate: date, validatedTerm }
}

function validateTerm(val:number, startDate:string|null, prop?:object){
  const property = prop || propertyService.get();
  const startMonth = underwritingService.getReportBeginDefault(true, property);
  // 1. The minimum Term = 1 year (enforced in reports' number inputs)
  // 2. The maximum Term = reportTerm (from above)
  if (val > getMaxTerm(startDate || startMonth)){
    // Adjust down to this.getReportTermDefault(val) and show error message
    let adjustedTerm = getMaxTerm(startDate || startMonth) <= 1 ? 1 : getMaxTerm(startDate || startMonth);
    notifcationService.notify({
      type: "warn",
      message: "Term adjusted to maximum allowable term",
      dismiss: 5000
    })
    return adjustedTerm;
  } else {
    return false;
  }
}

function validateStartDate(prop?:object) {
  const property = prop || propertyService.get();
  const propertyTerm = property['term'];
  // 1. The Start Date must greater than or equal to the Property Analysis Begin
  const minStartDate = property['analysisbegindate'];
  const reportBeginDate = property['reportbegindate'];
  // 2. The Start Date must be less than or equal to:
  let analysisBegin = minStartDate.split(/-/);
  let reportBegin = reportBeginDate.split(/-/);
  // If reportDateMonth <= analysisDateMonth:
  if (reportBegin[1] <= analysisBegin[1]){
    // reportDateMax = Month(reportDateMonth) and Year(analysisDateYear) + property.term + 1
    return [minStartDate, (`${Number(analysisBegin[0]) + propertyTerm + 1}-${reportBegin[1]}-${reportBegin[2]}`)]
  } else {
    // reportDateMax = Month(reportDateMonth) and Year(analysisDateYear) + property.term
    return [minStartDate, (`${Number(analysisBegin[0]) + propertyTerm}-${reportBegin[1]}-${reportBegin[2]}`)]
  }
}

function validateStartYear(y:string, t:number|null, params:object, options:string[]):number {
  const startYear = y.slice(-4) || params['start_year'].startYear.slice(-4);
  const term = t || params['term'];
  let firstYearEndDate = options[Object.keys(options)[0]].slice(-4);

  if (!(firstYearEndDate == startYear)){
    let adjustedTerm = options.length - (startYear - firstYearEndDate);
    if (term > adjustedTerm){
      notificationService.notify({
        type: "warn",
        message: "Term adjusted to maximum allowable term",
        dismiss: 5000
      })
      return adjustedTerm
    } else {
      return -1
    }
  } else return -1
}

function getDateRanges(report:string){
  const property         = propertyService.get();
  const analysisBegin    = property?.['analysisbegindate']
  const reportBegin      = property?.['reportbegindate']
  const anlaysisBeginArr = analysisBegin.split(/-/);
  const reportBeginArr   = reportBegin.split(/-/);
  let effectiveMonth     = report === 'Vacancy & Credit Loss Audit' ? property?.['datedetail']['vacancyCreditLossEffectiveMonth'] : property?.['datedetail']['recoveryEffectiveMonth']
  const monthNames       = {1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'};
  const monthNumbers     = {'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6, 'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12};

  // First year begin date is analysisbegindate month & year
  let firstDateStartMonth:string = monthNames[parseInt(anlaysisBeginArr[1])];
  if (effectiveMonth === 'Analysis Begin'){
    effectiveMonth = monthNames[parseInt(anlaysisBeginArr[1])];
  } else if (effectiveMonth === 'Report Begin'){
    effectiveMonth = monthNames[parseInt(reportBeginArr[1])];
  } else {
    effectiveMonth = effectiveMonth.substring(0, 3);
  }

  let firstDateEndMonth = monthNumbers[effectiveMonth] === 1 ? monthNames[12] : monthNames[monthNumbers[effectiveMonth] - 1];
  let firstDateEndYear:null|number = null

  if (monthNumbers[effectiveMonth] > monthNumbers[firstDateStartMonth] || monthNumbers[effectiveMonth] === 1){
    firstDateEndYear = anlaysisBeginArr[0];
  } else {
    firstDateEndYear = Number(anlaysisBeginArr[0]) + 1;
  }

  let firstOption:string = `${firstDateStartMonth} ${anlaysisBeginArr[0]} - ${firstDateEndMonth} ${firstDateEndYear}`;
  let startDateOptions:string[] = [];
  startDateOptions.push(firstOption);
  let term = firstDateStartMonth === effectiveMonth ? property?.['term'] : property?.['term'] + 1
  let currentYear = effectiveMonth === 'Jan' ? Number(firstDateEndYear) + 1 : Number(firstDateEndYear);
  for (let i=1; i < term; i++){
    let currentMonth = monthNumbers[firstDateEndMonth] + 1;
    if (currentMonth > 12) currentMonth = currentMonth % 12
    let startMonth = monthNames[currentMonth];
    let endMonth = currentMonth - 1 === 0 ? monthNames[12] : monthNames[currentMonth - 1];
    startDateOptions.push(`${startMonth} ${currentYear} - ${endMonth} ${effectiveMonth === 'Jan' ? currentYear : currentYear + 1}`);
    currentYear++;
  }

  return startDateOptions
}

function getMaxTerm(startDate){
  const property = propertyService.get();
  let date = startDate.includes('/') ? formatDate(startDate) : startDate
  // The Default Term calculation logic was provided as follows:
  // a. Determine analysisDateMonth (1-12) and analysisDateYear (e.g. 2018)
  // b. Determine reportDateMonth (1-12) and reportDateYear (e.g. 2018)
  // c. If reportDateMonth <= analysisDateMonth:
  // reportTerm = property.term - (reportDateYear - analysisDateYear) + 1
  // else:
  // reportTerm = property.term - (reportDateYear - analysisDateYear)
  const analysisBeginDate = property['analysisbegindate']
  const reportBeginDate = property['reportbegindate']
  const propertyTerm = property['term']
  let analysisBegin = analysisBeginDate.split(/-/);
  let reportBegin = date ? date.split(/-/) : reportBeginDate.split(/-/);

  if (Number(reportBegin[1]) <= Number(analysisBegin[1])){
    return (propertyTerm - (Number(reportBegin[0]) - Number(analysisBegin[0])) + 1);
  } else {
    return (propertyTerm - (Number(reportBegin[0]) - Number(analysisBegin[0])));
  }
}

function tenantCashFlowReport(tenants:number[]):void {
  const property = propertyService.get();
  const calcDetail = property['calcdetail']
  let {asObject: errors} = parseErrorsToErrorTable(property['errordetail'])
  errors = errors.filter(e => !_.includes(e.tags, `${e.type}:internal`) && !_.includes(e.tags, '*:severe'))

  if (!calcDetail || calcDetail.status !== "Calculated") {
    notificationService.notify({
      type: "warn",
      message: "You must run a calculation before running a report",
      dismiss: 3000
    })
    return
  }

  const payload = {
    propertyid: property['propertyid'],
    report: "tenant_cash_flow",
    params: {
      period: 12,
      report_style: "simple",
      start_month: property['reportbegindate'],
      tenants,
      term: property['term'],
      totals: 'false'
    },
    errors,
    output: {
      file_type: 'xlsx',
      timezone_offset: (new Date()).getTimezoneOffset()
    },
    use_auth: true
  }
  // let correlationid
  // return logEvent('property-report', {parameters: payload})
  // .then((cid) => correlationid = cid)
  Client.post(`reports/fileurl`, payload, {host: jsreport})
  .then(data => {
    let { id, message, success } = data;
    if (message){
      notificationService.notify({
        type: "warn",
        message,
        dismiss: 3000
      })
    }
    if (success === true) {
      Client.get(`reports/getfile/${id}`, { host: jsreport }).then((blob) => {
        const fileURL = window.URL.createObjectURL(blob)
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.download = `${id}.xlsx`
        fileLink.click()
      })
    }
  }).catch(err => {
    notificationService.notify({
      type: "warn",
      message: 'Report error encountered. Please contact support',
      dismiss: 3000
    })
  });
}

function propertyReport(payload):void {
  const currentProperty = !window.location.href.includes('asset-management') ? propertyService.get() : null
  let calcDetail = currentProperty?.['calcdetail'];
  const noCalcReports = [
    'asset_details',
    'attribute',
    'chart_detail',
    'hospitality_input_assumptions',
    'input_assumptions',
    'multifamily_input_assumptions',
    'portfolio_detail',
    'users',
    'user_group',
    '_comparison', // calc required but is enforced on the folder ui -- todo: this module is not properly designed for folder reports; refactor
    '_test_export',
  ]
  const noPropertyReports = [
    'asset_details',
    'attribute',
    'chart_detail',
    'portfolio_detail',
    'users',
    'user_group',
    '_comparison',
    "_test_export"
  ]

  if (!noCalcReports.includes(payload.report) && (!calcDetail || !['Calculated','Calculated with Warnings'].includes(calcDetail.status)) && !payload.report.includes('input_assumptions')) {
    notifcationService.notify({
      type: "warn",
      message: "Error: Must calculate property before running report.",
      dismiss: 5000
    })
  } else {
    if (!noPropertyReports.includes(payload.report)) payload.propertyid = currentProperty?.propertyid;

    payload.output = {
      file_type: 'xlsx',
      timezone_offset: (new Date()).getTimezoneOffset()
    }

    if (currentProperty){
      let {asObject: errors} = currentProperty ? parseErrorsToErrorTable(currentProperty['errordetail'], calcDetail) : null
      if (errors) errors = errors.filter(e => !_.includes(e.tags, `${e.type}:internal`) && !_.includes(e.tags, '*:severe'))
      payload.errors = errors;
    }
    payload.use_auth = true

    Client.post('reports/fileurl', payload, {host}).then((res)=>{
      let { id, message, success } = res;
      if (message){
        notifcationService.notify({
          type: success === true ? "warn": "danger",
          message,
          dismiss: 5000
        })
      }
      if (success === true) {
        Client.get(`reports/getfile/${id}`, {host}).then((blob) => {
          const fileURL = window.URL.createObjectURL(blob)
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.download = `${id}.xlsx`
          fileLink.click()
        })
      }
    }).catch(err => {
      notifcationService.notify({
        type: "danger",
        message: 'Report error encountered. Please contact support.',
        dismiss: 5000
      })
    })
  }
}

// public module interface //

const propertyReportService = {
  getDateRanges: (report: string) => getDateRanges(report),
  getReportTermDefault: () => getReportTermDefault(),
  tenantCashFlowReport: (rentrollid:number[]) => tenantCashFlowReport(rentrollid),
  getUnderwritingTermMax: (scenario:object) => getUnderwritingTermMax(scenario),
  propertyReport: (payload:object) => propertyReport(payload),
  updateDate: (date: string, term: number, prop?: object) => updateDate(date, term, prop),
  validateTerm: (val:number, startDate:string|null, prop?: object) => validateTerm(val, startDate, prop),
  validateStartDate: (prop?:object) => validateStartDate(prop),
  validateStartYear: (y:string, t:number|null, params:object, options:string[]) => validateStartYear(y, t, params, options)
}

export default propertyReportService